import React from 'react';
interface FooterProps {
  lang: 'en' | 'es';
}
export function Footer({
  lang
}: FooterProps) {
  return <footer className="border-t border-border/50 bg-[#050505] px-6 py-12" data-id="element-13">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 text-center" data-id="element-14">
        <p className="text-sm text-[#555555]" data-id="element-15">
          Simon Alvarado <span className="mx-2" data-id="element-16">|</span> simonpro.vip{' '}
          <span className="mx-2" data-id="element-17">|</span> Miami, FL
        </p>
        <p className="text-sm text-[#555555]" data-id="element-18">
          Bilingual Service — EN / ES <span className="mx-2" data-id="element-19">|</span> All Makes
          & Models <span className="mx-2" data-id="element-20">|</span> New & Pre-Owned
        </p>
        <p className="mt-4 text-xs text-[#333333]" data-id="element-21">
          © 2026 Simon Pro. All rights reserved.
        </p>
      </div>
    </footer>;
}